import Grid from 'components/Grid';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TopBar: FunctionComponent<Props> = ({ children, className = '', testId = TEST_ID }) => (
    <Grid className={`${className} ${styles.topBar}`} testId={testId}>
        {children}
    </Grid>
);

export default TopBar;
